import { useFormatter } from 'js/hooks/useFormatter';
import { usePortletTranslations } from 'js/components/system/Portlet';

export default ({ date }) => {
    const t = usePortletTranslations();
    const formatter = useFormatter();

    return date ? t('hint.til', [formatter.getDateTimeShort(date)]) : null;
};
